var include_information_archive = `
<div class="information-archive__wrap mt60 pt60 footer-adjustment">
	<div class="information-archive contents-wrap">
		<h3>年代別アーカイブ</h3>
		<div class="information-inner mt30">
			<ul id="js-information" class="information-archive__list">
				<li class="information-archive__list-item">
					<a href="/information/" id="js-information_archive_2025" class="information-archive__link js-information_current"><span>2025年</span></a>
				</li>
				<li class="information-archive__list-item">
					<a href="/information/2024.html" id="js-information_archive_2024" class="information-archive__link js-information_current"><span>2024年</span></a>
				</li>
				<li class="information-archive__list-item">
					<a href="/information/2023.html" id="js-information_archive_2023" class="information-archive__link js-information_current"><span>2023年</span></a>
				</li>
				<li class="information-archive__list-item">
					<a href="/information/2022.html" id="js-information_archive_2022" class="information-archive__link js-information_current"><span>2022年</span></a>
				</li>
				<li class="information-archive__list-item">
					<a href="/information/2021.html" id="js-information_archive_2021" class="information-archive__link js-information_current"><span>2021年</span></a>
				</li>
				<li class="information-archive__list-item">
					<a href="/information/2020.html" id="js-information_archive_2020" class="information-archive__link js-information_current"><span>2020年</span></a>
				</li>
				<li class="information-archive__list-item">
					<a href="/information/2019.html" id="js-information_archive_2019" class="information-archive__link js-information_current"><span>2019年</span></a>
				</li>
			</ul>
		</div>
	</div>
</div>
`;
